// @flow
import * as React from 'react';
import {
    Button,
    Columns,
    Column,
    Drawer,
    DrawerHeader,
    DrawerFooter,
    DrawerContent,
    Heading
} from '@locus-taxy/neo-ui';

import JsonForm from 'platform/settings/form/JsonForm';
import { type ContextData } from 'platform/settings/form/renderers/util/ctxToSettingsContextData';

import type { Metadata, ObjectProperties } from './types';

type Labels = {
    headerText: string,
    saveActionText: string,
    dismissActionText: string
};

type Value = {
    item: ObjectProperties,
    context: ContextData
};

type Props = {
    editMetadata: Metadata,
    i18n: $FixMe,
    labels: Labels,
    onDismiss: () => void,
    onDelete?: () => void,
    onSave: (data: ObjectProperties) => void,
    value: Value
};

const ObjectPropertiesEditDrawer = ({
    editMetadata,
    value: initialValue,
    i18n,
    labels,
    onDismiss,
    onDelete,
    onSave
}: Props): React.Node => {
    const [{ value, errors }, setData] = React.useState({
        errors: null,
        value: initialValue
    });

    const handleSave = () => {
        onSave(value.item);
    };

    const handleChange = (value, errors) => {
        setData({ value, errors });
    };

    return (
        <Drawer isOpen onDismiss={onDismiss}>
            <DrawerHeader>
                <Columns space="none" alignY="center">
                    <Column width="fluid">
                        <Heading>{labels.headerText}</Heading>
                    </Column>
                    {onDelete && (
                        <Column width="content">
                            <Button
                                appearance="icon"
                                icon="delete"
                                onClick={onDelete}
                                size="large"
                            />
                        </Column>
                    )}
                </Columns>
            </DrawerHeader>

            <DrawerContent>
                <JsonForm
                    metadata={editMetadata}
                    value={value}
                    i18n={i18n}
                    onChange={handleChange}
                />
            </DrawerContent>

            <DrawerFooter>
                <Button onClick={onDismiss}>{labels.dismissActionText}</Button>
                <Button
                    appearance="solid"
                    palette="primary"
                    onClick={handleSave}
                    disabled={Boolean(errors && errors.length > 0)}
                >
                    {labels.saveActionText}
                </Button>
            </DrawerFooter>
        </Drawer>
    );
};

export default ObjectPropertiesEditDrawer;
